module.exports = __webpack_public_path__ + "static/img/7.4bf088e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/3/sp/7.png
// module id = 1dvp
// module chunks = 0